export enum ApiError {
  OK = 0,
  ALREADY_EXISTS = 2,
  NOT_FOUND = 3,
  RECAPTCHA_FAILED = 4,
  PAGINATION_ERROR = 5,
  NO_ONE_PARAMS_INCOMING = 6,
  NEED_ADDITIONAL_PARAMS = 7,
}
